import { createWrapper } from "next-redux-wrapper";

import makeStore, { type AppStore } from "./store/make-store";

export { type AppStore };
export type AppDispatch = AppStore["dispatch"];

export const makeWrapper = (isDev: boolean) =>
  createWrapper<AppStore>(makeStore(isDev), {
    debug: isDev,
  });
